module.exports = __webpack_public_path__ + "static/media/tabs-icon-bookmark.cd9e2e82.svg";